module.exports = __webpack_public_path__ + "static/media/payment.918ae906.png";